import { defineStyle, defineStyleConfig } from "@chakra-ui/react";


const baseStyle = defineStyle({
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  border: "1px solid",
  borderRadius: "2px",
  bgColor: "#EFEFEF",
});

const primary = defineStyle({
  p: "6px 12px",
  color: "#fff",
  bgColor: "#337ab7",
  borderColor: "#2e6da4",
  borderRadius: "4px",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "normal",
  _hover: {
    bgColor: "#286090",
    borderColor: "#204d74",
  },
});

const addMore = defineStyle({
  ...primary,
  p: "5px 10px",
  borderRadius: "3px",
  fontSize: "12px",
  minH: "29px",
  minW: "29px",
  h: "initial",
});


const greenButton = defineStyle({
  h: "50px",
  w: "100%",
  maxW: "540px",
  p: "6px 12px",
  color: "white",
  bgColor: "#5cb85c",
  borderColor: "#4cae4c",
  borderRadius: "4px",
  fontSize: "23.8px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "34px",
  _hover: {
    bgColor: "#449d44",
    borderColor: "#398439",
  },
  _disabled: {
  },
});

const buttonTheme = defineStyleConfig({
  baseStyle,
  variants: { primary, greenButton , addMore},
});

export default buttonTheme;